(function () {
  'use strict';

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var REQUIRED = ['name', 'email', 'phone'];
  var MAX_FILE_BYTES = 3 * 1024 * 1024; // 3MB (keeps base64 JSON under Vercel's request limit)
  var ALLOWED_TYPES = ['image/', 'application/pdf'];

  function init(root) {
    var form = root.querySelector('[data-cwp-form]');
    if (!form) return;

    var submitBtn = root.querySelector('[data-cwp-submit]');
    var submitLabel = root.querySelector('.wd-cwp__submit-label');
    var successEl = root.querySelector('[data-cwp-success]');
    var errorEl = root.querySelector('[data-cwp-error]');
    var endpoint = root.getAttribute('data-api-endpoint') || '';

    var fileInput = root.querySelector('[data-cwp-file]');
    var dropzone = root.querySelector('[data-cwp-dropzone]');
    var fileText = root.querySelector('[data-cwp-file-text]');
    var fileClear = root.querySelector('[data-cwp-file-clear]');
    var fileError = root.querySelector('[data-cwp-file-error]');

    var defaultFileHtml = fileText ? fileText.innerHTML : '';
    var selectedFile = null;

    /* ---------- Submit ---------- */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      hideAlerts();

      if (!validate(form)) return;

      if (!endpoint || endpoint.indexOf('YOUR-VERCEL-PROJECT') !== -1) {
        showError();
        return;
      }

      setLoading(true);

      buildPayload(form)
        .then(function (payload) {
          return fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          });
        })
        .then(function (res) {
          if (!res.ok) throw new Error('Request failed');
          return res.json();
        })
        .then(function (data) {
          if (!data || data.success !== true) throw new Error('Unsuccessful');
          form.reset();
          clearInvalid(form);
          resetFile();
          showSuccess();
        })
        .catch(function () {
          showError();
        })
        .finally(function () {
          setLoading(false);
        });
    });

    form.addEventListener('input', function (e) {
      var field = e.target;
      if (field && field.classList && field.classList.contains('is-invalid')) {
        if (isFieldValid(field)) field.classList.remove('is-invalid');
      }
    });

    /* ---------- File handling ---------- */
    if (fileInput) {
      fileInput.addEventListener('change', function () {
        handleFiles(fileInput.files);
      });
    }

    if (fileClear) {
      fileClear.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        resetFile();
      });
    }

    if (dropzone) {
      ['dragenter', 'dragover'].forEach(function (evt) {
        dropzone.addEventListener(evt, function (e) {
          e.preventDefault();
          e.stopPropagation();
          dropzone.classList.add('is-dragover');
        });
      });
      ['dragleave', 'dragend', 'drop'].forEach(function (evt) {
        dropzone.addEventListener(evt, function (e) {
          e.preventDefault();
          e.stopPropagation();
          dropzone.classList.remove('is-dragover');
        });
      });
      dropzone.addEventListener('drop', function (e) {
        var dt = e.dataTransfer;
        if (dt && dt.files && dt.files.length) {
          if (fileInput) {
            try { fileInput.files = dt.files; } catch (_) {}
          }
          handleFiles(dt.files);
        }
      });
    }

    function handleFiles(fileList) {
      clearFileError();
      if (!fileList || !fileList.length) {
        resetFile();
        return;
      }

      var file = fileList[0];

      if (!isTypeAllowed(file)) {
        resetFile();
        showFileError('Please upload an image (PNG, JPG) or a PDF file.');
        return;
      }

      if (file.size > MAX_FILE_BYTES) {
        resetFile();
        showFileError('File is too large. Maximum size is 3MB.');
        return;
      }

      selectedFile = file;
      if (fileText) {
        fileText.innerHTML =
          '<strong>' + escapeText(file.name) + '</strong> · ' + formatSize(file.size);
      }
      if (dropzone) dropzone.classList.add('has-file');
      if (fileClear) fileClear.hidden = false;
    }

    function resetFile() {
      selectedFile = null;
      if (fileInput) fileInput.value = '';
      if (fileText) fileText.innerHTML = defaultFileHtml;
      if (dropzone) dropzone.classList.remove('has-file');
      if (fileClear) fileClear.hidden = true;
      clearFileError();
    }

    function isTypeAllowed(file) {
      var type = file.type || '';
      for (var i = 0; i < ALLOWED_TYPES.length; i++) {
        if (type.indexOf(ALLOWED_TYPES[i]) === 0) return true;
      }
      return false;
    }

    function showFileError(msg) {
      if (!fileError) return;
      fileError.textContent = msg;
      fileError.hidden = false;
    }

    function clearFileError() {
      if (!fileError) return;
      fileError.textContent = '';
      fileError.hidden = true;
    }

    /* ---------- Payload ---------- */
    function buildPayload(formEl) {
      var fd = new FormData(formEl);
      var payload = {
        name: (fd.get('name') || '').toString().trim(),
        email: (fd.get('email') || '').toString().trim(),
        phone: (fd.get('phone') || '').toString().trim(),
        message: (fd.get('message') || '').toString().trim(),
        companyWebsite: (fd.get('companyWebsite') || '').toString().trim()
      };

      if (!selectedFile) return Promise.resolve(payload);

      return readFileAsBase64(selectedFile)
        .then(function (base64) {
          payload.fileName = selectedFile.name;
          payload.fileType = selectedFile.type;
          payload.fileData = base64;
          return payload;
        })
        .catch(function () {
          return payload;
        });
    }

    function readFileAsBase64(file) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function () {
          var result = reader.result || '';
          var comma = String(result).indexOf(',');
          resolve(comma !== -1 ? String(result).slice(comma + 1) : String(result));
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    }

    /* ---------- Validation ---------- */
    function isFieldValid(field) {
      var name = field.name;
      var val = (field.value || '').trim();
      if (REQUIRED.indexOf(name) === -1) return true;
      if (!val) return false;
      if (name === 'email') return EMAIL_RE.test(val);
      return true;
    }

    function validate(formEl) {
      var valid = true;
      REQUIRED.forEach(function (name) {
        var field = formEl.querySelector('[name="' + name + '"]');
        if (!field) return;
        if (!isFieldValid(field)) {
          field.classList.add('is-invalid');
          valid = false;
        } else {
          field.classList.remove('is-invalid');
        }
      });
      if (!valid) {
        var first = formEl.querySelector('.is-invalid');
        if (first) first.focus();
      }
      return valid;
    }

    function clearInvalid(formEl) {
      formEl.querySelectorAll('.is-invalid').forEach(function (el) {
        el.classList.remove('is-invalid');
      });
    }

    /* ---------- Alerts / state ---------- */
    function hideAlerts() {
      if (successEl) successEl.hidden = true;
      if (errorEl) errorEl.hidden = true;
    }

    function showSuccess() {
      if (successEl) {
        successEl.hidden = false;
        successEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    function showError() {
      if (errorEl) {
        errorEl.hidden = false;
        errorEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    function setLoading(loading) {
      if (!submitBtn) return;
      submitBtn.disabled = loading;
      submitBtn.classList.toggle('is-loading', loading);
      if (submitLabel) submitLabel.textContent = loading ? 'Sending…' : 'Send';
    }

    /* ---------- Helpers ---------- */
    function formatSize(bytes) {
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1024 * 1024) return Math.round(bytes / 1024) + ' KB';
      return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    }

    function escapeText(str) {
      var div = document.createElement('div');
      div.textContent = String(str || '');
      return div.innerHTML;
    }
  }

  function boot() {
    document.querySelectorAll('wd-cwp.wd-cwp, .wd-cwp[data-section-id]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
